import * as CarePlanActions from './CarePlans'
import * as DataActions from './Data'
import * as FormActions from './Forms'
import * as GlobalActions from './Global'
import * as HandoverActions from './Handovers'
import * as LogActions from './Logs'
import * as ModalActions from './Modals'
import * as TodoActions from './Todos'

export default {
  ...CarePlanActions,
  ...DataActions,
  ...FormActions,
  ...GlobalActions,
  ...HandoverActions,
  ...LogActions,
  ...ModalActions,
  ...TodoActions
}
